import { Link } from 'gatsby';
import React, { useContext } from 'react';

import { MENU_DATA } from './data';

import * as styles from './mobile-menu-links.module.scss';
import { GlobalContext } from '../../store/global-state';
import { SIDEBAR_VIEWS } from '../../vitl-services/interfaces/blog';

interface Item {
  label: string;
  link: string;
}

type Items = Item[];

const MobileMenuLinks = () => {
  const { setSidebar } = useContext(GlobalContext);

  const closeSidebar = () => setSidebar(SIDEBAR_VIEWS.empty);

  const renderItem = (items: Items) => {
    return items.map(item => (
      <div onClick={closeSidebar}>
        <Link key={item.label} className={styles.link} to={item.link}>
          {item.label}
        </Link>
      </div>
    ));
  };
  return (
    <div className={styles.menuLinks}>
      {MENU_DATA.map(item => (
        <div key={item.label} className={styles.oneSection}>
          <p>{item.label}</p>
          {renderItem(item.items)}
        </div>
      ))}
    </div>
  );
};

export default MobileMenuLinks;
